// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27O4h","label":"styles_label__zv7_7"};